import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../misc/Column";
import type { Employee } from "../providers/employeesProvider";
import { EmployeeAvatar } from "../misc/EmployeeAvatar";

export function OfficeEmployeeMobileListItem(props: { employee: Employee; roleLabel: string; onClick: () => void }) {
  const { employee, roleLabel, onClick } = props;
  const theme = useTheme();
  const textColor = employee.disabled ? "text.disabled" : "text.primary";

  return (
    <ButtonBase
      data-testid="OfficeEmployeeMobileListItem"
      onClick={onClick}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Box sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}>
        <EmployeeAvatar src={employee.avatarUrl} sx={{ flexShrink: 0, height: 40, width: 40 }} />
        <Column sx={{ flex: 1, gap: 0.25, minWidth: 0 }}>
          <Typography variant="body1" color={textColor} sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
            {employee.name}
          </Typography>
          <Typography variant="caption" color={employee.disabled ? "text.disabled" : "text.secondary"}>
            {roleLabel}
          </Typography>
        </Column>
      </Box>
    </ButtonBase>
  );
}
